export default __webpack_public_path__ + "static/media/Settings-dark.c57a907d.svg";